import { getNewColumnOptions } from "./searchFields";
import { AdvancedSearchNewOptionType } from "../config/enums";
import { SearchColumn } from "./advancedSearch.types";
import { getSearchJoins } from "./advancedSearchRequest";

export interface FieldOption {
  Key: string;
  Value: string;
}

const entityFilters = (entityName: string) => [
  { Key: "advancedSearchEntityName", Value: entityName },
];

/** The fields a rule can be added on, joined entities included. */
export function getRuleFieldOptions(
  entityName: string,
  allowedEntityTypes: Record<string, string> | null | undefined,
  includeAllFields: boolean
): FieldOption[] {
  return (
    getNewColumnOptions(
      entityFilters(entityName),
      getSearchJoins(entityName, allowedEntityTypes),
      [],
      AdvancedSearchNewOptionType.Filters,
      includeAllFields
    ) ?? []
  );
}

/** The fields a column can be added for, less those already shown. */
export function getColumnFieldOptions(
  entityName: string,
  allowedEntityTypes: Record<string, string> | null | undefined,
  columns: SearchColumn[],
  includeAllFields: boolean
): FieldOption[] {
  return (
    getNewColumnOptions(
      entityFilters(entityName),
      getSearchJoins(entityName, allowedEntityTypes),
      columns,
      AdvancedSearchNewOptionType.Columns,
      includeAllFields
    ) ?? []
  );
}
